import {FormerMember} from "@/models/former-member"
import {ColumnDef} from "@tanstack/react-table"
import {useEffect, useState} from "react"
import {useDebounce} from "@/hooks/use-debounce"
import {DataTable} from "@/components/data-table.tsx"

interface FormerMemberDataTableProps {
    columns: ColumnDef<FormerMember, any>[]
    data: FormerMember[]
    searchTerm?: string
}

export function FormerMemberDataTable({columns, data, searchTerm = ""}: FormerMemberDataTableProps) {
    const [filteredData, setFilteredData] = useState<FormerMember[]>(data)

    const debouncedSearchTerm = useDebounce(searchTerm, 300)

    useEffect(() => {
            if (!debouncedSearchTerm.trim()) {
                setFilteredData(data)
                return
            }

            const filtered = data.filter(member => {
                const searchLower = debouncedSearchTerm.toLowerCase()

                const memberNoMatch = member.memberNo.toString().includes(debouncedSearchTerm)
                const nameMatch = `${member.firstName} ${member.lastName}`
                    .toLowerCase()
                    .includes(searchLower)
                const addressMatch = `${member.street} ${member.houseNumber ?? ''} ${member.postcode} ${member.city}`
                    .toLowerCase()
                    .includes(searchLower)
                const reasonMatch = (member.resignationReason ?? "")
                    .toLowerCase()
                    .includes(searchLower)

                return memberNoMatch || nameMatch || addressMatch || reasonMatch
            })

            setFilteredData(filtered)
        }, [debouncedSearchTerm, data]
    )

    return (
        <div className="space-y-4">
            <DataTable
                columns={columns}
                data={filteredData}
                resetPageKey={debouncedSearchTerm}
                data-testid="former-members-table"
            />
        </div>
    )
}
